import './index.scss';

import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import MenuIcon from '../../../assets/images/Menu.svg';
import HomeIcon from '../../../assets/images/home-black.svg';
import OfferIcon from '../../../assets/images/offers/offers-inactive.svg';
import BKWallIcon from '../../../assets/images/bk-wall.jpg';
import BkWallIconActive from '../../../assets/images/bk-wall-icon-active.svg';

import RestaurantFinderIcon from '../../../assets/images/dine-in-black.svg';
import {
  getHomeIcon,
  getMenuIcon,
  getOfferActiveImage,
  getRestaurantFinderImage
} from '../../utils/imageChanges';

const MobileFooter = props => {
  const { mobileFooterClick, activeKey, theme } = props;
  return (
    <div className="mob-footer">
      <div
        onClick={() => mobileFooterClick('home')}
        role="presentation"
        className="u_cursor_pointer"
      >
        <img
          src={activeKey === 'home' ? getHomeIcon(theme) : HomeIcon}
          alt="home"
        />
        <p className={`mob-footer__label ${activeKey === 'home' ? theme : ''}`}>
          Home
        </p>
      </div>
      {/* <div
        onClick={() => mobileFooterClick('menu')}
        role="presentation"
        className="u_cursor_pointer"
      >
        <img
          src={activeKey === 'menu' ? getMenuIcon(theme) : MenuIcon}
          alt="home"
        />
        <p className={`mob-footer__label ${activeKey === 'menu' ? theme : ''}`}>
          Menu
        </p>
      </div> */}
      <div
        onClick={() => mobileFooterClick('offers')}
        role="presentation"
        className="u_cursor_pointer"
      >
        <img
          src={activeKey === 'offers' ? getOfferActiveImage(theme) : OfferIcon}
          alt="offers"
        />
        <p
          className={`mob-footer__label ${activeKey === 'offers' ? theme : ''}`}
        >
          King Deals
        </p>
      </div>
      {!window?.sessionStorage?.getItem('THEATRE_RESPONSE') && (
        <div
          onClick={() => mobileFooterClick('stores')}
          role="presentation"
          className="u_cursor_pointer"
        >
          <img
            src={
              activeKey === 'stores'
                ? getRestaurantFinderImage(theme)
                : RestaurantFinderIcon
            }
            alt="stores"
            className="mob-footer__icon"
          />
          <p
            className={`mob-footer__label ${
              activeKey === 'stores' ? theme : ''
            }`}
          >
            Nearby Stores
          </p>
        </div>
      )}
    </div>
  );
};

MobileFooter.propTypes = {
  activeKey: PropTypes.string,
  theme: PropTypes.string,
  mobileFooterClick: PropTypes.func
};

MobileFooter.defaultProps = {
  activeKey: '',
  theme: '',
  mobileFooterClick: () => {}
};

export default withRouter(MobileFooter);
